import { MutableRefObject, useRef, useState } from "react";
import { INBOX_TAB } from "../../../Constants/notificationsWidgetTabNames";

export function useScrollToTop() {
	const [inboxListRef, setInboxListRef] = useState(useRef<HTMLElement>());
	const [archiveListRef, setArchiveListRef] = useState(useRef<HTMLElement>());

	const scrollToTopByRef = (ref: MutableRefObject<HTMLElement | undefined>) => {
		if (ref.current) {
			ref.current.scrollTo({ top: 0, behavior: "smooth" });
		}
	};

	const scrollToTopByTabName = (tabName: string) => {
		scrollToTopByRef(getRefByName(tabName));
	};

	const scrollToTop = () => {
		scrollToTopByRef(inboxListRef);
		scrollToTopByRef(archiveListRef);
	};

	const getRefByName = (name: string) => {
		return name === INBOX_TAB ? inboxListRef : archiveListRef;
	};

	return {
		scrollToTopByRef,
		scrollToTop,
		getRefByName,
		scrollToTopByTabName,
		refs: { inboxListRef, archiveListRef },
		setters: { setInboxListRef, setArchiveListRef },
	};
}
